import jwt from "jsonwebtoken";

export const isAuth = () => {
  const token = sessionStorage.getItem("token");
  if (!token) return false;

  var decodedToken = jwt.decode(token, { complete: true });
  var dateNow = new Date();

  console.log("isAuth", decodedToken.payload.exp < dateNow.getTime());
  return decodedToken.payload.exp < dateNow.getTime();
};

export const getUserIdFromToken = () => {
  const token = sessionStorage.getItem("token");
  if (!token) return false;

  var decodedToken = jwt.decode(token, { complete: true });

  return decodedToken.payload.user_id;
};
